import React from 'react';
import { PropTypes } from 'prop-types';

// Components
import SearchEventsUpcomingNoQuery from '../../searches/SearchEventsUpcomingNoQuery/index.js';
import LoadingArea from '@molecules/LoadingArea';
import { DivWithShadowAlternate, H4, BodyLarge } from '@styled';

// Functionality
import useCompanyFull from '@hooks/useCompanyFull.js';

const CompanyProfileUpcomingEvents = ({ graphID }) => {
    const { data: companyData, loading } = useCompanyFull(graphID);

    if (!companyData || loading) {
        return <LoadingArea />;
    }

    const companyEvents = !companyData.events ? null : companyData.events.filter(Boolean);

    return (
        <div className="col-lg-12 mt-4">
            <H4 className="mb-1.5rem">Upcoming Events</H4>
            <DivWithShadowAlternate className="p-4" style={{ width: '100%' }}>
                {!companyEvents.length && (
                    <BodyLarge className="mb-1.875rem">This company is currently not attending any events.</BodyLarge>
                )}

                {companyEvents && companyEvents.length > 0 && <SearchEventsUpcomingNoQuery events={companyEvents} />}
            </DivWithShadowAlternate>
        </div>
    );
};

CompanyProfileUpcomingEvents.propTypes = {
    graphID: PropTypes.string,
};

export default CompanyProfileUpcomingEvents;
